import React, { Component } from "react";
import {
  Accordion,
  Button,
  Grid,
  Header,
  Icon,
  Image,
  List,
} from "semantic-ui-react";

const accordionStyle = {
  marginRight: "10%",
  borderLeft: "solid #f37021 3px",
  borderRight: "solid #d1d6db 1px",
  borderTop: "solid #d1d6db 1px",
  borderBottom: "solid #d1d6db 1px",
  padding: "15px",
};
export default class SolutionAccordion extends Component {
  state = { activeIndex: 0 };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;

    return (
      <Grid stackable verticalAlign="top">
        <Grid.Row columns={2}>
         {!this.props.isMobile&&  <Grid.Column>
            {activeIndex === 0 && (
              <Image src="/solution_accordion_education.png" className="hide-in-mobile" />
            )}
            {activeIndex === 1 && (
              <Image src="/solution_accordion_enterprise.png" className="hide-in-mobile" />
            )}
            {activeIndex === 2 && (
              <Image src="/solution_accordion_healthcare.png" className="hide-in-mobile" />
            )}
            {activeIndex === 3 && (
              <Image src="/solution_accordion_mobility.png" className="hide-in-mobile" />
            )}
          </Grid.Column>}
         
          <Grid.Column>
            <Accordion fluid>
              {" "}
              <Accordion.Title
                as={Header}
                active={activeIndex === 0}
                index={0}
                onClick={this.handleClick}
                style={{fontSize:"28px"}}
              >
                <Icon name="dropdown" />
                  教育
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 0}>
                <div style={accordionStyle}>
                  <p style={{fontSize:"24px"}}>ネイティブの英語教師を補う</p>
                  <List bulleted style={{fontSize:"24px"}}>
                    <List.Item>MUSE教育API</List.Item>
                    <List.Item>Musio English</List.Item>
                    <List.Item>コンテンツ出版 & パートナーシップ</List.Item>
                  </List>
                <a href="jp/solution/education" style={{ color: "#F2711C", fontSize:"24px" }}>
                  詳しくはこちら <Icon name="arrow right" />
                </a>
                </div>
              </Accordion.Content>
              <Accordion.Title
                as={Header}
                active={activeIndex === 1}
                index={1}
                onClick={this.handleClick}
                style={{fontSize:"28px"}}
              >
                <Icon name="dropdown" />
                ビジネス
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 1}>
                <div style={accordionStyle}>
                  <p style={{fontSize:"24px"}}>企業のために人間の労働者を補う</p>
                  <List bulleted style={{fontSize:"24px"}}>
                    <List.Item>Muse J X Ken Robotech</List.Item>
                    <List.Item>Muse J X VAIO</List.Item>
                  </List>
                  <a href="/solution/enterprise" style={{ color: "#F2711C", fontSize:"24px" }}>
                    詳しくはこちら <Icon name="arrow right" />
                  </a>
                </div>
              </Accordion.Content>
              <Accordion.Title
                as={Header}
                active={activeIndex === 2}
                index={2}
                onClick={this.handleClick}
                style={{fontSize:"28px"}}
              >
                <Icon name="dropdown" />
                  ヘルスケア
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 2}>
                <div style={accordionStyle}>
                  <p style={{fontSize:"24px"}}>介護者を補う</p>
                  <List bulleted style={{fontSize:"24px"}}>
                    <List.Item>ReSmart</List.Item>
                    <List.Item>MusioAliveX場面緘黙症</List.Item>
                  </List>
                  <a href="/solution/health" style={{ color: "#F2711C" , fontSize:"24px"}}>
                    詳しくはこちら <Icon name="arrow right" />
                  </a>
                </div>
              </Accordion.Content>
              <Accordion.Title
                as={Header}
                active={activeIndex === 3}
                index={3}
                onClick={this.handleClick}
                style={{fontSize:"28px"}}
              >
                <Icon name="dropdown" />
                モビリティ
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 3}>
                <div style={accordionStyle}>
                  <p style={{fontSize:"24px"}}>人間の運転者を補う</p>
                  <List bulleted style={{fontSize:"24px"}}>
                    <List.Item>同行者（ドライビングコンパニオン）</List.Item>
                    <List.Item>MUSEのメモリ構造</List.Item>
                  </List>
                  <a href="/solution/mobility" style={{ color: "#F2711C", fontSize:"24px"  }}>
                  詳しくはこちら <Icon name="arrow right" />
                  </a>
                </div>
              </Accordion.Content>
            </Accordion>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
